// extracted by mini-css-extract-plugin
export default {"thingsToKnowWarp":"Tqh5mLyZlaGDTFUiWX2dj","thingsToKnowText":"_1FPfEr36yGBhxv0xnDDgni"};